<template>
	<div style="width:100%;">
	    <el-autocomplete v-model="current" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" @select="handleSelect" style="width:100%;"></el-autocomplete>
    </div>
</template>

<script>
	import axios from 'axios';
	import { ElMessage,ElMessageBox,ElNotification} from 'element-plus';
	import tool from "@/utils/tool"
	export default{
		props:{
			request:{
				type:Object,
				default:{
					url:'',
					params:{},
					method:"get"
				}
			},
			labelkey:{//适配转化为label的对应字段
				type:String,
				default:''
			},
			valuekey:{//适配转化为value的对应字段
				type:String,
				default:''
			},
			modelValue:{
				type:String,
				default:''
			}
		},
		data(){
			return{
                current:''
			}
		},
		mounted(){
			this.current=this.modelValue;
		},
		methods:{
			async querySearchAsync(queryString, cb) {
				var that=this;
				if(this.request.url){
					axios({
						method:this.request.method||'get',
						url:this.request.url,
						params:{
							keyword:queryString
						}
					}).then((response) => {
						if(response.data&&response.data.data){
							let dataList=response.data.data;
							var results =queryString?dataList.filter(that.createFilter(queryString)):dataList;
							let arr=tool.objCopy(results);
							if(arr&&arr.length){
								arr.forEach((item,index)=>{
									arr[index].value=item[that.labelkey];
									arr[index].choosedAimId=item[that.valuekey];
								});
								cb(arr);
							}
						}
					}).catch((error) => {
						ElNotification.error({
							title: '请求错误',
							message:'服务器发生错误！'
						});
					})
				}

			},
			createFilter(queryString) {
				return (state) => {
				    return (state.F_Name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
				};
			},
			handleSelect(selected) {
				this.$emit('update:modelValue',selected.choosedAimId);
			}
		}
	}
</script>

<style>
</style>
